import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface FamilyOfficeAllocationState {
    data: [] | null | any;
    currentPage: number | null;
    totalRecords: number | null;
    totalPages: number | null;
    allFamilyOfficeAllocation: [] | null | any;
}

const initialState: FamilyOfficeAllocationState = {
    data: null,
    totalRecords: null,
    totalPages: null,
    currentPage: null,
    allFamilyOfficeAllocation: null,
};

export const familyOfficeAllocationSlice = createSlice({
    name: 'FamilyOfficeAllocation',
    initialState,
    reducers: {
        setFamilyOfficeAllocation: (state, action) => {
            state.data = action.payload.data?.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data?.totalRecords;
            state.totalPages = action.payload.data?.totalPages;
            state.currentPage = action.payload.data?.currentPage;
        },
        setFamilyOfficeAllocationBySearch: (state, action) => {
            state.data = action.payload.data?.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data?.totalRecords;
            state.totalPages = action.payload.data?.totalPages;
            state.currentPage = action.payload.data?.currentPage;
        },
        setAllFamilyOfficeAllocation: (state, action) => {
            state.allFamilyOfficeAllocation = action.payload.data;
        },
        reset: (state) => {
            Object.assign(state, initialState);
        },
    },
});

export const {
    setFamilyOfficeAllocation,
    setFamilyOfficeAllocationBySearch,
    setAllFamilyOfficeAllocation,
    reset,
} = familyOfficeAllocationSlice.actions;

export const getAllFamilyOfficeAllocationDetails = (state: RootState) => state.familyOfficeAllocation.data;
export const getFamilyOfficeAllocationTotalRecords = (state: RootState) => state.familyOfficeAllocation.totalRecords;
export const getAllFamilyOfficeAllocationBySearch = (state: RootState) => state.familyOfficeAllocation.data;

export default familyOfficeAllocationSlice.reducer;
